import React from 'react';
import { Result, Button, Typography, Space } from 'antd';
import { ReloadOutlined, SyncOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

interface DataLoadErrorProps {
  onRetry?: () => void;
  errorMessage?: string;
}

const DataLoadError: React.FC<DataLoadErrorProps> = ({ 
  onRetry, 
  errorMessage = '数据加载失败，请稍后重试' 
}) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100%', 
      minHeight: 300 
    }}>
      <Result
        status="error"
        title="数据加载失败"
        subTitle={errorMessage}
        extra={
          <Space size="large">
            {onRetry && (
              <Button 
                type="primary" 
                icon={<ReloadOutlined />}
                onClick={onRetry}
              >
                重新加载
              </Button>
            )}
            <Button 
              icon={<SyncOutlined />}
              onClick={() => window.location.reload()}
            >
              刷新页面
            </Button>
          </Space>
        }
      >
        <div style={{ textAlign: 'center' }}>
          <Paragraph>
            <strong>您可以尝试以下操作：</strong>
          </Paragraph>
          <Paragraph>
            1. 检查网络连接是否正常
          </Paragraph>
          <Paragraph>
            2. 点击"刷新页面"按钮重试
          </Paragraph>
          <Paragraph>
            3. 如果问题持续存在，请联系系统管理员
          </Paragraph>
        </div>
      </Result>
    </div>
  );
};

export default DataLoadError;